import { useState } from 'react';

export type ShareCode = {
  uuid: string;
  value: string;
  allowsMultiRedeemWithSelf: boolean;
  allowsMultiRedeemWithOthers: boolean;
  incentiveDurationDays: number | null;
};

export type LookupShareCodeResult = {
  shareCode: ShareCode;
};

export const useLookupShareCode = () => {
  const [error, setError] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(false);

  const lookupShareCode = async (
    shareCodeValue: string,
  ): Promise<LookupShareCodeResult | undefined> => {
    setError(undefined);
    setIsLoading(true);

    const response = await fetch(
      `https://api.pushtrainingapp.com/share-codes/lookup?code=${shareCodeValue}`,
      {
        method: 'GET',
      },
    ).catch(() => {
      setError(`Failed to fetch.`);
      return null;
    });

    setIsLoading(false);

    if (!response) {
      return undefined;
    }
    const responseBody = await response.json();
    setIsLoading(false);

    if (responseBody.error) {
      setError(responseBody.error.description);
      return undefined;
    }
    if (response.ok) {
      return responseBody.data;
    }
    throw Error('Unexpected API result.');
  };

  return { lookupShareCode, isLoading, error };
};
